import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Alert, Button, Column, Container, Icon, Modal, Row } from '@pella/sash-framework';
import { isValidArray } from '../../../../utilities/validations';

import PccZipForm from '../pcc-zip-form';
import FindContractorHeader from '../find-contractor-header';
import PccCard from '../pcc-card';
import PccQuoteForm from '../pcc-quote-form';
import FAQ from '../../../faq';

import './index.css';

const PCCForm = ({ data }) => {
	const locations = useSelector((state) => state.locations);
	const [platinumList, setPlatinumList] = useState([]);
	const [certifiedList, setCertifiedList] = useState([]);
	const [buildPCCList, setBuildPccList] = useState([]);
	const [quoteRequests, setQuoteRequests] = useState(0);
	const [activeStep, setActiveStep] = useState(1);
	const [activeFilter, setActiveFilter] = useState(false);
	const [stickyCta, setStickyCta] = useState(false);
	const [truncateText, setTruncateText] = useState({});
	const [show, setShow] = useState({
		showPPCCElite: '',
		showPPCC: '',
		showPCC: '',
	});

	useEffect(() => {
		window.addEventListener('scroll', onMobileScroll, { passive: true });
		window.addEventListener('click', onOverlayClick);
		return () => {
			window.removeEventListener('scroll', onMobileScroll);
			window.removeEventListener('click', onOverlayClick);
		};
	}, []);

	useEffect(() => {
		setPlatinumList(locations.platinum);
		setCertifiedList(locations.certified);
		setActiveFilter(false);
	}, [locations.platinum, locations.certified]);

	const tallyQuoteRequest = (action, selectedPCC) => {
		setQuoteRequests(action === 'add' ? quoteRequests + 1 : quoteRequests - 1);

		if (action === 'add') {
			var newPCCList = buildPCCList.slice();

			newPCCList.push(selectedPCC);
			setBuildPccList(newPCCList);
		}

		if (action === 'subtract') {
			const newfilterPCCList = buildPCCList.filter((pcc) => pcc.id !== selectedPCC.id);
			setBuildPccList(newfilterPCCList);
		}
	};

	const getQuotes = () => {
		const sortPPCList = buildPCCList;

		let showPPCCElite = [];
		let showPPCC = [];
		let showPCC = [];

		for (let i = 0; i < sortPPCList.length; i++) {
			if (sortPPCList[i].level == 'Platinum Elite') {
				showPPCCElite.push(sortPPCList[i]);
			} else if (sortPPCList[i].level == 'Platinum') {
				showPPCC.push(sortPPCList[i]);
			} else {
				showPCC.push(sortPPCList[i]);
			}
		}

		setShow({
			...show,
			showPPCCElite: showPPCCElite,
			showPPCC: showPPCC,
			showPCC: showPCC,
		});
	};

	const onStepChange = (step) => {
		setActiveStep(step);

		// const item = document.querySelector(`.pcc-form-step-${activeStep}`);
		// item?.scrollIntoView({ behavior: 'smooth' });
	};

	const onMobileFilterClick = () => {
		document.body.classList.toggle('zip-modal-active');
		setActiveFilter(!activeFilter);
	};

	const onMobileScroll = () => {
		if (window.innerWidth >= 768) return;

		const scrollTarget = document.querySelector('.pcc-form-step-1 .pcc-search-form');
		const scrollPosition = scrollTarget.getBoundingClientRect().bottom;
		const onetrust = document.querySelector('.ot-floating-button');
		const quiq = document.querySelector('.quiq-floating-element');

		if (scrollPosition <= 0) {
			setStickyCta(true);
			if (onetrust) onetrust.style.bottom = '90px';
			if (quiq) quiq.style.bottom = '74px';
		} else {
			setStickyCta(false);
			if (onetrust) onetrust.style.bottom = '';
			if (quiq) quiq.style.bottom = '';
		}
	};

	const onReadMoreClick = (value) => setTruncateText({ ...truncateText, [value]: !truncateText[value] });

	const onOverlayClick = (event) => {
		// TODO: Move to sash-framework for all Modals.
		if (event.target.classList.contains('sash-Modal-Overlay')) setActiveFilter(false);
	};

	return (
		<div data-testid='pcc-form'>
			<div
				id={data?.anchor}
				className='bg-gray-3 py-8'
				data-testid='find-contractors'
			>
				<Container>
					{data?.heading && <h2 className='mb-6 font-bold'>{data.heading}</h2>}

					{isValidArray(data?.steps) && (
						<div className='mb-2.5 hidden border border-gray-10 bg-white px-6 py-8 text-center md:block'>
							<Row>
								{data.steps.map((step, index) => (
									<Column
										xs='fluid'
										key={index}
									>
										<p className='text-subtitle inline-block bg-primary px-2 py-1.5'>{step.step}</p>
										<p className='mt-5 font-semibold text-black'>{step.step_heading}</p>
									</Column>
								))}
							</Row>
						</div>
					)}
				</Container>

				<Container className='max-md:px-0'>
					<div
						className={`pcc-form-step-1 mb-2.5 overflow-hidden border border-gray-10 max-md:border-x-0 ${activeStep === 1 ? 'active-step bg-white' : ''}`}
						data-testid='pcc-step-1'
					>
						<FindContractorHeader
							step={1}
							data={data.steps[0]}
							activeStep={activeStep}
							onBtnClick={() => {
								if (activeStep === 1) {
									getQuotes();
									onStepChange(2);
								} else {
									onStepChange(1);
								}
							}}
							selectedContractors={quoteRequests}
						/>

						<div className={`pcc-step-body p-6 xl:px-12 ${activeStep !== 1 ? 'hidden' : ''}`}>
							<div className='pcc-search-form mb-6'>
								<Row align='end'>
									<Column
										xs={12}
										lg={4}
									>
										<p className='mb-4 font-semibold text-gray-60'>Show Pella Certified Contractors near:</p>
									</Column>

									<Column
										xs={12}
										md={8}
										lg={5}
									>
										<PccZipForm />

										<Modal
											isOpen={activeFilter}
											onClose={onMobileFilterClick}
											className='!m-0 w-full rounded-t-2xl px-4 pb-6 pt-16 [&>button>span]:bg-transparent [&>button>span]:text-black'
											backdropClass='flex items-end !px-0 backdrop-blur-[2px] bg-gray-60/30 md:hidden'
											width='100%'
											data-testid='pcc-zip-modal'
										>
											<PccZipForm />
										</Modal>
									</Column>

									<Column
										xs={12}
										md={4}
										lg={3}
										className='mt-5 text-center md:mt-0 lg:text-right'
									>
										<Row
											className='gap-x-1'
											noGutters
										>
											<Column xs='fluid'>
												<p className='text-body-2 mb-4 text-gray-60'>Select up to three contractors</p>

												<Button
													color='primary'
													disabled={quoteRequests > 0 && quoteRequests < 4 ? false : true}
													className='px-5 py-0 !leading-[46px]'
													size='sm'
													onClick={() => {
														getQuotes();
														onStepChange(2);
													}}
												>
													{data.steps[0].cta}
												</Button>
											</Column>
										</Row>
									</Column>
								</Row>
							</div>

							<div className='md:max-h-[680px] md:overflow-y-auto md:border md:border-gray-10 md:px-4 md:py-6 xl:max-h-[980px] xl:p-10'>
								<div>
									<h2>Platinum Pella Certified Contractors</h2>
									<p className={`max-w-[80ch] xl:mb-6 ${!truncateText.platinum ? 'max-xl:line-clamp-1' : ''}`}>Platinum Pella Certified Contractors have earned Pella&apos;s highest level of certification for independent contractors. That means they have the product and installation know-how to deliver an end result you&apos;ll love.</p>
									<button
										onClick={() => onReadMoreClick('platinum')}
										className='mb-6 underline hover:no-underline xl:hidden'
									>
										{truncateText.platinum ? 'Show Less' : 'Read More'}
									</button>

									{!isValidArray(platinumList) && (
										<Alert
											type='error'
											hideClose={true}
											className={`my-4 text-center`}
										>
											Currently there are no Platinum Pella Certified Contractors in your area.
										</Alert>
									)}

									{isValidArray(platinumList) &&
										platinumList.map((platinum, index) => (
											<PccCard
												data={platinum}
												key={index}
												tallyQuoteRequest={tallyQuoteRequest}
												disabled={quoteRequests >= 3}
											/>
										))}
								</div>

								<div className='mt-12'>
									<h2>Pella Certified Contractors</h2>
									<p className={`max-w-[80ch] xl:mb-6 ${!truncateText.certified ? 'max-xl:line-clamp-1' : ''}`}>Pella Certified Contractors and their experience with Pella windows and doors means they can easily help you find the right product and install it for you.</p>
									<button
										onClick={() => onReadMoreClick('certified')}
										className='mb-6 underline hover:no-underline xl:hidden'
									>
										{truncateText.certified ? 'Show Less' : 'Read More'}
									</button>

									{!isValidArray(certifiedList) && (
										<Alert
											type='error'
											hideClose={true}
											className={`my-4 text-center`}
										>
											Currently there are no Pella Certified Contractors in your area.
										</Alert>
									)}

									{isValidArray(certifiedList) &&
										certifiedList.map((certified, index) => (
											<PccCard
												data={certified}
												key={index}
												tallyQuoteRequest={tallyQuoteRequest}
												disabled={quoteRequests >= 3}
											/>
										))}
								</div>

								<div
									className={`fixed left-0 z-[16] w-full border-t border-t-gray-10 bg-white px-6 py-2 transition-all duration-500 md:static md:mt-5 md:w-auto md:border-0 md:p-0 md:text-right ${stickyCta ? 'bottom-0' : '-bottom-full'}`}
									data-testid='pcc-sticky-cta'
								>
									<Row
										className='gap-1'
										justify='end'
										noGutters
									>
										<Column
											xs='fluid'
											md='auto'
										>
											<Button
												color='primary'
												disabled={quoteRequests > 0 && quoteRequests < 4 ? false : true}
												className='px-5 py-0 !leading-[46px] md:w-fit'
												size='sm'
												onClick={() => {
													getQuotes();
													onStepChange(2);
												}}
												wide
											>
												{data.steps[0].cta}
											</Button>

											<p className='text-body-2 text-center text-gray-60'>Select up to three contractors</p>
										</Column>

										<Column
											xs='auto'
											className={stickyCta ? 'md:hidden' : 'hidden'}
										>
											<Button
												color='secondary'
												onClick={onMobileFilterClick}
												className='h-[48px] py-0'
												aria-label='Update Zip Code'
											>
												<Icon name='filter_list' />
											</Button>
										</Column>
									</Row>
								</div>
							</div>
						</div>
					</div>

					<div
						className={`pcc-form-step-2 mb-2.5 overflow-hidden border border-gray-10 max-md:border-x-0 ${activeStep <= 2 ? 'bg-white' : ''} ${activeStep === 2 ? 'active-step' : ''}`}
						data-testid='pcc-step-2'
					>
						<FindContractorHeader
							step={2}
							data={data.steps[1]}
							activeStep={activeStep}
							onBtnClick={onStepChange}
							selectedContractors={quoteRequests}
						/>

						{activeStep == 2 && (
							<div className='pcc-step-body p-6'>
								<PccQuoteForm
									ppccEliteData={show.showPPCCElite}
									ppccData={show.showPPCC}
									pccData={show.showPCC}
									onSubmit={onStepChange}
								/>
							</div>
						)}
					</div>

					<div
						className={`pcc-form-step-3 mb-2.5 overflow-hidden border border-gray-10 max-md:border-x-0 ${activeStep <= 3 ? 'bg-white' : ''} ${activeStep === 3 ? 'active-step' : ''}`}
						data-testid='pcc-step-3'
					>
						<FindContractorHeader
							step={3}
							data={data.steps[2]}
							activeStep={activeStep}
							selectedContractors={quoteRequests}
						/>

						<div className={`pcc-step-body p-6 ${activeStep !== 3 ? 'hidden' : ''}`}>
							<h2 className='mb-6'>{data.steps[2].heading}</h2>
							<p className='mb-6 max-w-[80ch]'>{data.steps[2].description}</p>

							{isValidArray(data.steps[2].faqs.faq) && (
								<div className='bg-gray-3 p-8'>
									{data.steps[2].faqs.heading && <h3 className='mb-6'>{data.steps[2].faqs.heading}</h3>}
									<FAQ
										data={data.steps[2].faqs.faq}
										multipleColumns
									/>
								</div>
							)}
						</div>
					</div>
				</Container>
			</div>
		</div>
	);
};

PCCForm.propTypes = {
	data: PropTypes.object,
};

export default PCCForm;
